<template>
    <div class="uk-margin-small-top uk-width-1-1" id="telegramFile">
        <div id="files-area" class="uk-margin-small uk-padding-xsmall uk-text-center">
            <div id="filesList">
                <div id="files-names" class="uk-grid uk-grid-collapse uk-child-width-1-1" data-uk-grid></div>
            </div>
        </div>
        <div v-if="files.length != 0" class="uk-margin-small uk-text-center files-area-txt uk-text-muted uk-text-small" @paste="testPasteImg">
            {{ keys_pages.label_downloading_a_file }}
        </div>
        <div class="uk-margin-top-small uk-text-center">
            <!--      <label for="attachment">-->
            <button class="uk-button uk-button-primary tm-button-add uk-text-light" style="color: #fff" @click="uploadFile">
                + {{ keys_pages.button_add_screenshot }}
            </button>
            <!-- aria-disabled="false"-->
            <!--      </label>-->
            <input type="file" name="file[]" accept=".png,.jpg,.jpeg,.gif,.webp" id="attachment" hidden="hidden" multiple @change="uploadPreviewFiles"/>
        </div>
    </div>
</template>

<script>
export default {
  name: "MultipleImgUploadComponentt",
  props: {
    keys_pages: {
      type: Object,
      require: true
    },
    files: {
      type: Array,
    },
  },
  data: () => ({

  }),
  methods: {
    uploadFile() {
      let filesInput = document.getElementById('attachment');
      filesInput.click();
    },
    uploadPreviewFiles(event) {
      for (let file of event.target.files) {
        let fileCont = document.createElement('div');
            fileCont.classList.add("file-block", "uk-animation-slide-bottom-small", "uk-display-block");
        let fileBlock = document.createElement('div');
            fileBlock.classList.add("uk-grid", "uk-grid-small", "uk-child-width-auto", "uk-flex-middle");
        let filePrevBox = document.createElement('div');
            filePrevBox.classList.add("uk-width-auto");
        let filePrev = document.createElement('div');
            filePrev.classList.add("prev-img");
            filePrev.style.backgroundImage = "url('"+ URL.createObjectURL(file) +"')";


        // let filePrevImg = document.createElement('img');
        //     filePrevImg.src = URL.createObjectURL(file);
        let fileName = document.createElement('div');
            fileName.classList.add("tm-file-name", "uk-width-expand", "uk-text-left");
            fileName.innerHTML = file.name;
        let fileDelBlock = document.createElement('div');
        let fileDel = document.createElement('div');
            fileDel.classList.add("tm-file-delete", "uk-icon");
            fileDel.innerHTML = '<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke="#000" stroke-width="1.06" d="M16,16 L4,4"></path><path fill="none" stroke="#000" stroke-width="1.06" d="M16,4 L4,16"></path>';
            fileDel.onclick = () => { this.deleteFileFromList(file, fileCont) };
            // filePrev.append(filePrevImg);
            filePrevBox.append(filePrev);
            fileDelBlock.append(fileDel);
            fileBlock.append(filePrevBox);
            fileBlock.append(fileName);
            fileBlock.append(fileDelBlock);
            fileCont.append(fileBlock);
        let filesField = document.getElementById('files-names');
            filesField.append(fileCont);
        let telegFile = document.querySelector('#telegramFile');
            telegFile.classList.remove('tm-val-error');
        this.files.push(file)
      }
    },
    testPasteImg(event) {

    },
    deleteFileFromList(file, fileCont) {
      this.files.splice(this.files.indexOf(file), 1);
      let filesField = document.getElementById('files-names');
          filesField.removeChild(fileCont);
    }
  },
  created() {

  }
};
</script>

<style></style>